<template>
  <ul v-if="apps.length" class="nav nav-sidebar">
    <li class="nav-item-header text-center" v-text="headerText" />
    <li v-for="app in apps" :key="app.url" class="nav-item p-2">
      <a :href="app.url" target="_blank" class="text-center">
        <b-img :src="app.image_url" fluid />
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'MobileAppLinks',

  data() {
    return {
      apps: [],
      headerText: null,
    }
  },

  mounted() {
    this.$http.get('mobile-apps').then(response => {
      this.apps = response.data['mobile-apps'] || []
      this.headerText = response.data['header_text']
    })
  },
}
</script>
